
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfDispositionInteractionIconProps extends SvgIconProps {}
/**
 * component used display to disposition interaction icon
 * @param props - CcfDispositionInteractionIconProps
 * @example - <CcfDispositionInteractionIcon />
 * @returns SVG of disposition interaction icon
 */
export function CcfDispositionInteractionIcon(
  props: CcfDispositionInteractionIconProps
) {
  return (
    <SvgIcon {...props}>
      <g id="ic_outcomes" clip-path="url(#clip-ic_outcomes)">
        <g
          id="Group_111999"
          data-name="Group 111999"
          transform="translate(2.658 2.973)"
        >
          <g
            id="Rectangle_36235"
            data-name="Rectangle 36235"
            transform="translate(0 1.054)"
            fill="none"
            strokeWidth="2"
            strokeDasharray="4 2"
          >
            <rect width="18" height="18" stroke="none" />
            <rect x="1" y="1" width="16" height="16" fill="none" />
          </g>
          <path
            id="Path_13285"
            data-name="Path 13285"
            d="M7184.107-369.5l4.375,4.5,10.2-11.77"
            transform="translate(-7179 376.768)"
            fill="none"
            strokeLinecap="round"
            strokeWidth="3"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfDispositionInteractionIcon;
